import { GOOGLE_SPREADSHEET_GID, GOOGLE_SPREADSHEET_ID } from "Constants/Common";
import { IAttachable } from "Interfaces/IAttachable";
import { ICellData } from "Interfaces/ICellData";
import { IStudentMap } from "Interfaces/IStudentMap";
import Sheet from "Models/Sheet";
import { ISchaleStudent, SchaleStudent } from "Models/Student";
import { getJson } from "Utils/Common";

const SCHALE = "https://schaledb.com"

export interface IStudentMapData {
	name:string;
	id:string;
}
export default class StudentMap implements 
		IAttachable {
	initialized: boolean = false;
	static map: IStudentMap = {};
	static revMap: IStudentMap = {};
	static studentNames: string[] = [];
	static schaleStudent: SchaleStudent[] = [];
	static schaleTask: Promise<SchaleStudent[]>;

	async initialize() {
		const students = new Sheet(GOOGLE_SPREADSHEET_ID, GOOGLE_SPREADSHEET_GID.STUDENTS).initialize();
		const schedSheet = new Sheet("1l-SI54lhBaEeV5c1AmVyzDqHgQyjhqLOMfz1adQ3vGw", "546306050").initialize();
		const thoughts = new Sheet(GOOGLE_SPREADSHEET_ID, GOOGLE_SPREADSHEET_GID.THOUGHTS).initialize();
		// const test = await new Sheet("1gr1s87uS89StUT9E0e0jBM-PM8zLdGN4CPjhBi1xnsU", "1814121765").initialize();
		// console.log(test);
		
		// const fullDataUrl = `https://schaledb.com/data/en/students.min.json`;
		// const schale:Promise<{[id:number]: ISchaleStudent}> = getJson(fullDataUrl);
		try {
			// Prone to mapping errors due to data schema changes on Schale
			// StudentMap.populateSchale(Object.values(await schale));
			StudentMap.schaleTask = StudentMap.populateSchaleLanguages()
		} catch {
			console.error("Error loading Schale Student List");
		}
		new StudentMap()
			.populateId(await students)
			.populateId(await schedSheet)
			.populateAlias(await thoughts);
		this.initialized = true;
	}

	static async populateSchaleLanguages() {
		// function delay(ms: number) {
		// 	return new Promise( resolve => setTimeout(resolve, ms) );
		// }
		// await delay(5000);
		// do in background to prevent slowdown
		const fullDataUrl = `https://schaledb.com/data/en/students.min.json`;
		const schale:Promise<{[id:number]: ISchaleStudent}> = getJson(fullDataUrl);
		try {
			// Prone to mapping errors due to data schema changes on Schale
			StudentMap.populateSchale(Object.values(await schale));
		} catch {
			console.error("Error loading Schale Student List");
		}

		const langs = ['jp', 'kr', 'cn', 'th'];
		// const schaleLangs:Promise<{[id:number]: ISchaleStudent}>[] = langs.map(lang => getJson(`https://schaledb.com/data/${lang}/students.min.json`));
		const schaleLangs:Promise<{[id:number]: ISchaleStudent}>[] = [];

		try {
			// Prone to mapping errors due to data schema changes on Schale
			for (const schaleLang of schaleLangs) {
				StudentMap.populateSchaleLanguage(Object.values(await schaleLang));
			}
		} catch {
			console.error("Error loading Schale Student List");
		}

		return StudentMap.schaleStudent;
	}

	attach(data: ICellData[]) {
		const student = StudentMap.parseRow(data);
		if (student.id !== "") {
			StudentMap.map[student.name.toLocaleLowerCase()] = student.id;
			StudentMap.revMap[student.id] = student.name;
			StudentMap.studentNames.push(student.name);
		}
	}
	static populateSchale( source: ISchaleStudent[]) {
		StudentMap.schaleStudent = this.populateSchaleLanguage(source);
	}

	static populateSchaleLanguage(source: ISchaleStudent[]) {
		const schaleStudents = source.map(s => new SchaleStudent(s)).filter((s, _, self) => {
			const copies = self.filter((s2) => s.Name === s2.Name)
			return copies.length === 1 || copies.sort((a,b)=>a.Id-b.Id)[0].Id === s.Id;
		});
		for (const student of schaleStudents) {
			if (!!!StudentMap.map[student.name.toLocaleLowerCase()]) {
				StudentMap.map[student.name.toLocaleLowerCase()] = student.id.toString();
				if (!!!StudentMap.revMap[student.id])
					StudentMap.revMap[student.id] = student.name;
				StudentMap.studentNames.push(student.name);
			}
			for (const alias of student.SearchTags) {
				if (!!!StudentMap.map[alias.toLocaleLowerCase()]) {
					StudentMap.map[alias.toLocaleLowerCase()] = student.id.toString();
					StudentMap.studentNames.push(alias);
				}
			}
		}

		return schaleStudents;
	}

	populateId(source: Sheet) {
		for (const i in source.getTable().rows) {
			const r = source.getTable().rows[i];
			this.attach(r.c);
		}

		return this;
	}

	populateAlias(source: Sheet) {
		for (const i in source.getTable().rows) {
			const r = source.getTable().rows[i];
			const name = r.c[1]?.v ?? '';
			const id = this.getId(name);
			const aliases = r.c[3]?.v?.split('\n') ?? [];
			// this.attach(r.c);
			for ( const alias of aliases) {
				StudentMap.map[alias.toLocaleLowerCase()] = id;
				StudentMap.studentNames.push(alias);
			}
		}
		return this;
	}

	getId(studentName: string) {
		try {
			return StudentMap.map[studentName.toLocaleLowerCase()] ?? undefined;
		} catch {
			return "";
		}
	}
	getIdFromUnknown(student: string) {
		return this.getId(this.getProperName(student));
	}
	getProperName(studentName:string) {
		const temp = this.getId(studentName);
		if (temp)
			return this.getName(temp);
		return this.getName(studentName);
	}

	findStudents(student: string) {
		const matches = this.getStudentNames()
			.filter(s => s.toLowerCase().startsWith(student.toLowerCase()))
			.map(s => this.getProperName(s));
		return [...new Set(matches)];
	}

	getName(studentId: string) {
		try {
			return StudentMap.revMap[studentId] ?? undefined;
		} catch {
			return undefined;
		}
	}

	getStudentNames() {
		return StudentMap.studentNames;
	}

	getSchale(studentName: string) {
		const id = this.getId(studentName);
		if (id === "") return SCHALE;
		return `${SCHALE}/student/${id}`
	}

	getIconSwap(id: string | number) {
		const now = new Date();
		const swap = {
			'26005': {
				until: new Date("2025-08-24T00:00:00Z"),
				img: "/img/PortraitSwap/Yoshimi_Mummy_Portrait_Icon.png"
			}
		}
		if (swap[id.toString()] && now <= swap[id.toString()].until) {
			return swap[id.toString()].img;
		}
		return undefined;
	}
	

	getIcon(studentName: string | number, isRound?: boolean) {
		let id;
		if (typeof(studentName) === "number")
			id = studentName;
		else if(studentName?.match(/\d+/g)) 
			id = parseInt(studentName);
		else
			id = this.getId(studentName);
		if (!!!id || id === "") return "";
		if (isRound)
			return `${SCHALE}/images/student/icon/${id}.webp`
		const swap = this.getIconSwap(id);
		if (swap) return swap;
		return `${SCHALE}/images/student/collection/${id}.webp`
	}

	static parseRow(data:ICellData[]): IStudentMapData {
		return {
			name: data[0]?.v ?? '',
			id: data[15]?.v ?? '',
		};
	}
}